import {BudgetDayCounters, RosterData} from '@/types/types';
import Dates from '@cquential/date-utils';
import {BudgetAmount, RosterDayDeploymentCountConfigurationBalances} from '@cquential/api';

export default class BudgetDayCounterUtil {
    public static get(roster: RosterData, balances?: RosterDayDeploymentCountConfigurationBalances): BudgetDayCounters {
        if (balances === undefined || !roster.budgets?.length) {
            return {};
        }
        const budgetCounters: BudgetDayCounters = {};
        for (const budget of roster.budgets) {
            if (budget.id && budget.amounts?.length && budget.deploymentCountConfiguration.id) {
                const configId: number = budget.deploymentCountConfiguration.id;

                for (const day of roster.days) {
                    const formattedDate: string = Dates.Formatter.formatDateComputerFriendly(day.date);
                    const amount: BudgetAmount | undefined = budget.amounts.find((value: BudgetAmount): boolean => {
                        return value.date.getTime() === day.date.getTime();
                    });

                    if (!budgetCounters[budget.id]) {
                        budgetCounters[budget.id] = {};
                    }

                    budgetCounters[budget.id][formattedDate] = {
                        date: day.date,
                        budgetAmount: amount ? amount.amountInSeconds / 3600 : null,
                        usedAmount: balances[configId][formattedDate] ?? null,
                    };
                }
            }
        }

        return budgetCounters;
    }
}
